export default __webpack_public_path__ + "src/assets/icn-liquidity.00ee17c43dac99bce0695b17b7d818f0.svg";